import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { MonitoringService } from '@core/services/monitoring.service';
import { aggregator } from '@env/aggregator/aggregator';
import { Announcement } from '@features/dashboard/models/announcement';
import { DashboardService } from '@features/dashboard/services/dashboard.service';

@Component({
  selector: 'app-announcement-list',
  templateUrl: './announcement-list.component.html',
  styleUrls: ['./announcement-list.component.scss']
})
export class AnnouncementListComponent implements OnInit {
  public announcements$!: Observable<Announcement[]>;
  aggregatorName = aggregator.name;

  constructor(
    private monitoringService: MonitoringService,
    private dashboardService: DashboardService
  ) {}

  ngOnInit(): void {
    this.announcements$ = this.dashboardService.getAnnouncements();
  }

  public openItem(announcement: Announcement): void {
    this.monitoringService.logEvent('Download', {
      file: {
        id: announcement.id,
        name: announcement.name
      },
      view: 'dashboard'
    });

    window.open(announcement.url, '_blank');
  }
}
